import { Pipe, PipeTransform } from '@angular/core';

import moment from 'moment-timezone';

@Pipe({
  name: 'rtDateFormatTimezone',
  standalone: true,
})
export class DateFormatTimezonePipe implements PipeTransform {
  public transform(date: string | Date, timezone: string, format?: string): string {
    return moment(date).tz(timezone).format(format);
  }
}
